<template>
    <a class="nav-link" @click="showMessages()">
        <i class="fa fa-envelope-o" aria-hidden="true"></i>
        <span v-if="unreadMessagesCount" class="badge bg-warning navbar-badge">{{ unreadMessagesCount }}</span>
    </a>
</template>

<script>
import { mapState } from 'vuex'

export default {
    data() {
        return {
            
        };
    },
    methods: {
        showMessages(){
            this.$parent.$refs.messagesModal.showMessages();
        }
    },
    computed: {
        ...mapState({
            unreadMessagesCount: state => state.messages.unreadMessagesCount ?? 0
        }),
    },
    mounted(){
        this.$store.dispatch('messages/getUnreadMessagesCount');
    }
};
</script>

<style scoped>
.unread {
    font-weight: bold;
}

.navbar-badge{
    right: 0;
}
</style>